import { getTempInfo } from '../../common.js';
import { Toast } from 'antd-mobile/lib';
import Util from '../../util.js'
import { validateTransactionPassword } from '../investmentAction'
export function myInvestmentList(text) {
	return {
		type: "INVESTMENT_LIST",
		text: text
	}
}
export function myInvestmentListOver(text) {
  return {
    type: "INVESTMENT_LIST_OVER",
    text: text
  }
}
export function myInvestmentDetial(text) {
	return {
		type: "INVESTMENT_DETIAL",
		text: text
	}
}
export function myInvestmentFundList(text) {
	return {
		type: "INVESTMENT_FUN_LIST",
		text: text
	}
}
//定投计划列表
export const getInvestmentList=()=> {
	return (dispatch, getState)=> {
    Toast.loading('', 0);
		getTempInfo( 'shortToken' ).then( (d)=>{ 
      let data={
        token:d,pageSize:'9999'
      }
      console.log(d)
      Util.get(Util.url+"/api/plan/queryPlanList",data,function(result){
      	if (result.code=='0000') {
          Toast.hide()
          let newDate = result.content.records.filter(function(item) { 
            return item.fundCode.startsWith('SF')
          });
          result.content.records=newDate
      		dispatch(myInvestmentList(result))
      	} else {
         Toast.info(result.message, Util.ToastTime );
        }
      	console.log(result,'---oooo111');
      },function(error){
       Toast.info( Util.errorTxt, Util.ToastTime );
        console.log('jiekou error');
        
      },60)
    }).catch( (err)=>{ Toast.info( Util.errorTxt, Util.ToastTime )} )
	}
}
//定投计划列表
export function getInvestmentListOver() {
  return function(dispatch, getState) {
    Toast.loading('', 0);
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      let data={
        token:d,pageSize:'99999'
      }
      Util.post(Util.url+"/api/plan/queryPlanList",data,function(result){
        if (result.code=='0000') {
          dispatch(myInvestmentList(result));
          Toast.hide()
        } else {
         Toast.info(result.message, Util.ToastTime );
        }
        
        console.log(result,'---oooo111');
      },function(error){
       Toast.info( Util.errorTxt, Util.ToastTime );
        console.log('jiekou error');
        
      })
    }).catch( (err)=>{ Toast.hide()} )
  }
}
//定投计划详情
export function getInvestmentDetial(planId,callback) {
  return function(dispatch, getState) {
    callback()
    Toast.loading('', 0);
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      let data={
        token:d,
        planId:planId
      }
      console.log(data)
      Util.get(Util.url+"/api/plan/findSinglePlan",data,function(result){
        if (result.code=='0000') {
          dispatch(myInvestmentDetial(result.content));
          Toast.hide()
        } else {
         Toast.info(result.message, Util.ToastTime );
        }
        console.log(result)
        callback()
      },function(error){
        callback()
        Toast.hide()
       Toast.info( Util.errorTxt, Util.ToastTime );
        console.log('jiekou error')
      })
    }).catch( (err)=>{ Toast.hide() } )
  }
}
//定投计划历史
export function getInvestmentHistory(data,successCallback) {
  return function(dispatch, getState) {
     
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      console.log(data)
      Util.get(Util.url+"/api/plan/queryPayHistory",data,function(result){
        if (result.code=='0000') {
          successCallback(result.content.records)
          console.log(result,'12213123123')
        } else {
         Toast.info(result.message, Util.ToastTime );
        }
         
      },function(error){
       Toast.info( Util.errorTxt, Util.ToastTime );
         
      })
    }).catch( (err)=>{   } )
  }
}
//定投基金列表
let getVal=(property)=>{
    return function(a,b){
        var value1 = a[property];
        var value2 = b[property];
        return value2 - value1;
    }
}
export const getInvestmentFundList=(callback)=> {
	return (dispatch, getState)=> {
      Toast.loading('', 0);
      Util.get(Util.url+"/api/plan/queryCommonBuyPlanFundList",{},function(result){
        if (result.code=='0000') {
          let obj={ZT:[],GP:[],HH:[],HB:[],ZQ:[],ZS:[],LC:[]};
          let SF1022=[];
          let SF1067=[];
          let SF1060=[];
          let SF1039=[];
          let SF1038=[];
          let SF1036=[];
          let SF1021=[];
          let SF1020=[];
          let SF1019=[];
          let SF1018=[];
          let SF1017=[];
          let SF1016=[];
          let SF1015=[];
          let SF1014=[];
          let SF1013=[];
          let SF1012=[];
          let jingzhi=[]
          let wanfenshouyi=[]
          result.content.forEach((item,i)=>{
            if (item.fundTypeName=='股票型') {
              obj.GP.push(item);
              jingzhi.push(item)
            } else if (item.fundTypeName=='混合型') {
              obj.HH.push(item);
              jingzhi.push(item)
            } else if (item.fundTypeName=='货币型') {
              obj.HB.push();
              wanfenshouyi.push(item)
            } else if (item.fundTypeName=='债券型') {
              obj.ZQ.push(item);
              jingzhi.push(item)
            } else if (item.fundTypeName=='指数型') {
              obj.ZS.push(item);
              jingzhi.push(item)
            } else if (item.fundTypeName=='理财型') {
              obj.LC.push(item);
              wanfenshouyi.push(item);
            } else if(item.fundTypeName=='超级基金型'){ 
              try{
                // if(Util.superFundCodeArr(item.fundCode) == -1){
                    eval(item.fundCode).push(item)
                // }
              }catch(error){

              }
            }
          })
          jingzhi.sort(getVal('zhangdiefu',false));
          wanfenshouyi.sort(getVal('qirinianhua',false));
          obj.ZT=[...SF1022,...SF1067,...SF1060,...SF1039,...SF1038,...SF1036,...SF1021,...SF1020,...SF1019,...SF1018,...SF1017,...SF1016,...SF1015,...SF1014,...SF1013,...SF1012];
          // let all=[...obj.ZT,...jingzhi,...wanfenshouyi];
          let all=[...obj.ZT];
          callback(all,obj.ZT,obj.GP,obj.HH,obj.HB,obj.ZQ,obj.ZS,obj.LC)
          Toast.hide()
        } else {
         Toast.info(result.message, Util.ToastTime );
        }
      	console.log(result)
        
      },function(error){
        
       Toast.info( Util.errorTxt, Util.ToastTime );
        console.log('jiekou error',error)
      })
	}
}
//定投终止
export function getStopBuyPlan(data,callback) {
  return function(dispatch, getState) {
    Toast.loading('', 0);
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      console.log('定投终止:',data)
      dispatch(validateTransactionPassword(data,(c)=>{
        if (!c) {Toast.info( '交易密码错误', Util.ToastTime );return;} 
        Util.get(Util.url+"/api/plan/stopBuyPlan",data,function(result){
          Toast.hide()
          if (result.code=='0000') {
            callback(1,result)
          } else {
            callback(3,result.message)
          }
        },function(error){
          callback(3, Util.errorTxt)
        })
      },(m)=>{
         Toast.info( m, Util.ToastTime );
      }))
    }).catch( (err)=>{ Toast.hide() } )
  }
}
export function getStopPlan(data,callback) {
  return function(dispatch, getState) {
    Toast.loading('', 0);
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      console.log('定投终止HQT:',data)
      dispatch(validateTransactionPassword(data,(c)=>{
        if (!c) {Toast.info( '交易密码错误', Util.ToastTime );return;} 
        Util.get(Util.url+"/api/plan/stopPlan",data,function(result){
          Toast.hide()
          if (result.code=='0000') {
            callback(1,result)
          } else {
            callback(3,result.message)
          }
        },function(error){
          callback(3,Util.errorTxt)
        })
      },(m)=>{
         Toast.info( m, Util.ToastTime );
      }))
    }).catch( (err)=>{ Toast.hide() } )
  }
}
export function moneyFundPlanStopValidate(data,callback) {
  return function(dispatch, getState) {
    Toast.loading('', 0);
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      dispatch(validateTransactionPassword(data,(c)=>{
        if (!c) {Toast.info( '交易密码错误',Util.ToastTime);return;} 
        Util.post(Util.url+"/api/paybymoneyfund/moneyFundPlanStopValidate",data,function(result){
          if (result.code=='0000') {
            Util.post(Util.url+"/api/paybymoneyfund/moneyFundPlanStopSubmit",data,function(result){
              console.log(result)
              if (result.code=='0000') {
                let id=result.content;
                result.content={planId:id}
                callback(1,result)
              } else {
                callback(3,result.message)
              }
              Toast.hide()
            },function(error){
              callback(3,Util.errorTxt)
              Toast.hide()
            })
          } else {
            Toast.info(result.message,Util.ToastTime);
          }
        },function(error){
          Toast.info( Util.errorTxt,Util.ToastTime);
        })
      },(m)=>{
          Toast.info( m,Util.ToastTime);
      }))
    }).catch( (err)=>{ Toast.hide(); } )
  }
}
//新建定投
export function createBuyPlan(data,callback) {
  return function(dispatch, getState) {
    Toast.loading('', 0);
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      data.clientType=Util.return_Clinet_Type();
      console.log('定投入参:',data)
      dispatch(validateTransactionPassword(data,(c)=>{
        if (!c) {Toast.info( '交易密码错误', Util.ToastTime );return;} 
        Util.get(Util.url+"/api/plan/createBuyPlan",data,function(result){
            Toast.hide()
          if (result.code=='0000') {
            callback(1,result);
          } else {
            callback(0,result.message)
          }
        },function(error){
          callback(0,Util.errorTxt)
        })
      },(m)=>{
         Toast.info( m, Util.ToastTime );
      }))
    }).catch( (err)=>{ Toast.hide()} )
  }
}

//直销卡新建定投
export function createBuyPlanzxk(data,callback) {
  return function(dispatch, getState) {
    Toast.loading('', 0);
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      data.clientType=Util.return_Clinet_Type();
      console.log('定投入参:',data)
      dispatch(validateTransactionPassword(data,(c)=>{
        if (!c) {Toast.info( '交易密码错误', Util.ToastTime );return;} 
        Util.get(Util.url+"/api/v1/plan/camcBankCardPlan/createPlan",data,function(result){
          console.log(result,"111111")
            Toast.hide()
          if (result.code=='0000') {
            callback(1,result);
          } else {
            callback(0,result.message)
          }
        },function(error){
          callback(0,Util.errorTxt)
        })
      },(m)=>{
         Toast.info( m, Util.ToastTime );
      }))
    }).catch( (err)=>{ Toast.hide()} )
  }
}
//活期通账号新建定投
export function createPlan(data,callback) {
  return function(dispatch, getState) {
    Toast.loading('', 0);
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      data.clientType=Util.return_Clinet_Type();
      console.log('定投入参:',data)
      dispatch(validateTransactionPassword(data,(c)=>{
        if (!c) {Toast.info( '交易密码错误', Util.ToastTime );return;} 
        Util.get(Util.url+"/api/plan/createPlan",data,function(result){
          Toast.hide()
          if (result.code=='0000') {
            callback(1,result)
          } else {
            callback(3,result.message)
          }
        },function(error){
          callback(3, Util.errorTxt)
        })
      },(m)=>{
         Toast.info( m, Util.ToastTime );
      }))
    }).catch( (err)=>{  } )
  }
}
//智投定投
export function dttByMoneyFundSubmit(data,callback) {
  return function(dispatch, getState) {
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      data.clientType=Util.return_Clinet_Type();
      Util.post(Util.url+"/api/paybymoneyfund/dttByMoneyFundSubmit",data,function(result){
        console.log(result)
        if (result.code=='0000') {
          let id=result.content;
          result.content={planId:id}
          callback(1,result)
        }else{
          callback(3,result.message)
        }
      },function(error){
        callback(3,Util.errorTxt)
      })
    }).catch( (err)=>{ callback(3,Util.errorTxt) } )
  }
}
export function dttByMoneyFundValidate(data,callback) {
  return function(dispatch, getState) {
    Toast.loading('', 0);
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      data.clientType=Util.return_Clinet_Type();
      dispatch(validateTransactionPassword(data,(c)=>{
        if (!c) {Toast.info( '交易密码错误',Util.ToastTime );return;}
        Util.post(Util.url+"/api/paybymoneyfund/dttByMoneyFundValidate",data,function(result){
          if (result.code=='0000') {
            callback()
          }else{
            Toast.info(result.message,Util.ToastTime );
          }
        },function(error){
          Toast.info( Util.errorTxt,Util.ToastTime );
        })
      },(m)=>{
        Toast.info( m,Util.ToastTime );
      }))
    }).catch( (err)=>{ Toast.hide(); } )
  }
}
//修改定投
export function modifyBuyPlan(data,callback) {
  return function(dispatch, getState) {
    Toast.loading('', 0);
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      console.log('修改入参:',data)
      dispatch(validateTransactionPassword(data,(c)=>{
        if (!c) {Toast.info( '交易密码错误', Util.ToastTime );return;} 
        Util.get(Util.url+"/api/plan/modifyBuyPlan",data,function(result){
          Toast.hide()
          if (result.code=='0000') {
            callback(1,result)
          } else {
            callback(3,result.message)
          }
        },function(error){
          Toast.hide()
          callback(3,Util.errorTxt)
        })
      },(m)=>{
         Toast.info( m, Util.ToastTime );
      }))
    }).catch( (err)=>{  } )
  }
}
export function modifyPlan(data,callback) {
  return function(dispatch, getState) {
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      console.log('修改入参:',data)
      dispatch(validateTransactionPassword(data,(c)=>{
        if (!c) {Toast.info( '交易密码错误', Util.ToastTime );return;} 
        Util.get(Util.url+"/api/plan/modifyPlan",data,function(result){
          Toast.hide()
          if (result.code=='0000') {
            callback(1,result)
          } else {
            callback(3,result.message)
          }
        },function(error){
          Toast.hide()
          callback(3,Util.errorTxt)
        })
      },(m)=>{
          
         Toast.info( m, Util.ToastTime );
      }))
    }).catch( (err)=>{  } )
  }
}
export function moneyFundPlanModifyValidate(data,callback) {
  return function(dispatch, getState) {
    Toast.loading('', 0);
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      data.clientType='hxcfApp';
      console.log('修改入参:',data)
      dispatch(validateTransactionPassword(data,(c)=>{
        if (!c) {Toast.info( '交易密码错误', Util.ToastTime);return;} 
        Util.get(Util.url+"/api/paybymoneyfund/moneyFundPlanModifyValidate",data,function(result){
            console.log(result)
          if (result.code=='0000') {
            Util.post(Util.url+"/api/paybymoneyfund/moneyFundPlanModifySubmit",data,function(result){
              if (result.code=='0000') {
                let id=result.content;
                result.content={planId:id}
                callback(1,result)
              } else {
                Toast.info(result.message, Util.ToastTime);
              }
            },function(error){
              Toast.info( Util.errorTxt, Util.ToastTime);
            })
          } else {
            Toast.info(result.message, Util.ToastTime);
          }
        },function(error){
          Toast.info( Util.errorTxt, Util.ToastTime);
        })
      },(m)=>{
          Toast.info( m, Util.ToastTime);
      }))
    }).catch( (err)=>{ Toast.hide() } )
  }
}




// WEBPACK FOOTER //
// ./src/action/myAssets/InvestPlanAction.js